import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, ArrowLeftIcon } from 'lucide-react';
import { CONTACT } from '../data/modalities';
interface Props {
  title: string;
  description: string;
}
export function ComingSoon({
  title,
  description
}: Props) {
  return <section className="mx-auto flex min-h-[62vh] w-full max-w-3xl flex-col items-center justify-center px-5 py-24 text-center sm:px-8" data-id="element-323" data-mp="3vgv4xldlb61i">
      <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-teal" data-id="element-324" data-mp="dagw20u6hm9z">
        Coming Soon
      </p>
      <h1 className="mt-4 font-display text-4xl font-extrabold leading-tight tracking-tight text-navy sm:text-5xl" style={{
      fontWeight: 800
    }} data-id="element-325" data-mp="98vl4l17fi2f">
        {title}
      </h1>
      <p className="mt-5 max-w-xl text-[16px] leading-relaxed text-charcoal/70" data-id="element-326" data-mp="i2qqnu68nail">
        {description}
      </p>
      <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-327" data-mp="wx52nardxjnr">
        <a href={CONTACT.phoneHref} className="inline-flex items-center justify-center gap-2 rounded-full bg-navy px-7 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-navy/90" data-id="element-328" data-mp="s17jyxsng17t">
          <PhoneIcon className="h-[18px] w-[18px]" data-id="element-329" data-mp="125cuhqfzof3g" />
          Call {CONTACT.phone}
        </a>
        <Link to="/" className="inline-flex items-center justify-center gap-2 rounded-full border border-slate-200 bg-white px-7 py-3.5 text-[15px] font-semibold text-navy transition-colors hover:border-teal hover:text-teal" data-id="element-330" data-mp="165dcfl2ar8f9">
          <ArrowLeftIcon className="h-[18px] w-[18px]" data-id="element-331" data-mp="1l35p85gglipr" />
          Back to Home
        </Link>
      </div>
    </section>;
}